import {StoreType} from '../../../types/sharedTypes';


export const allLocationsSelector = (state: StoreType) => {
  return state.locationReducer.locationsResult;
}
